import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { DatePipe, DOCUMENT } from '@angular/common';

declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [DatePipe],
})
export class HeaderComponent implements OnInit {
  /**
   * Fecha actual del sistema
   */
  public currentDate: string | null;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private datePipeService: DatePipe
  ) {}

  ngOnInit() {
    // Asegura que la primera vez que carga la aplicación la información de la fecha y hora
    // ya se encuentre ahí
    this.createDate();
    // Actualiza cada segundo la información de fecha y hora
    setInterval(() => {
      this.createDate();
    }, 1000);
  }

  /**
   * Guarda la fecha y hora actual del sistema
   * @method createDate
   * @returns {void}
   */
  createDate(): void {
    const date = new Date();
    this.currentDate = this.transform(this.datePipeService.transform(date, "EEEE, d 'de' MMMM 'de' y, h:mm:ss a", '', 'es'));
  }

  /**
   * Capitaliza la primera letra de la fecha
   * @method transform
   * @returns {string | null}
   */
  transform(value:string | null): string | null {
    if (value) {
      let first = value.substr(0,1).toUpperCase();
      return first + value.substr(1);
    }
    return null;
  }
}
